import Vue from 'vue';
import layout from '@/components/shared/layout/layout.vue';
import navbar from '@/components/shared/navbar/navbar.vue';
import sidebar from '@/components/shared/sidebar/sidebar.vue';
import breadcrumb from '@/components/shared/breadcrumb/breadcrumb.vue';
import quickview from '@/components/shared/quickview/quickview.vue';

Vue.component('layout', layout);
Vue.component('navbar', navbar);
Vue.component('sidebar', sidebar);
Vue.component('breadcrumb', breadcrumb);
Vue.component('quickview', quickview);

//base components
import baseTable from '@/components/base/baseTable/baseTable.vue';
import baseSelect from '@/components/base/baseSelect/baseSelect.vue';
import baseTreeselect from '@/components/base/baseTreeSelect/baseTreeSelect.vue';
Vue.component('baseTable', baseTable);
Vue.component('baseSelect', baseSelect);
Vue.component('baseTreeSelect', baseTreeselect);

//App components

//Third party components
//Vue multiselect
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'
Vue.component('multiselect', Multiselect)

//Tree select
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
Vue.component('treeselect', Treeselect)

